<div class="read-only">
  <div class="read-only__title label">
    {{title}}
  </div>
  <div class="read-only__content">
    <ng-container *ngIf="!checkValue; else checkedValue">
      <ng-content></ng-content>
    </ng-container>
  </div>
</div>

<ng-template #checkedValue>
  <div *ngIf="value">
    {{ value }}
  </div>
  <div *ngIf="!value">&ndash;</div>
</ng-template>
